export default __webpack_public_path__ + "static/media/i_travel_medium_grey.c16b4964.png";